import { Component, OnInit, inject } from '@angular/core';
import { PagesService } from '../pages.service';
import { FormsModule } from '@angular/forms';
import { NotificationsComponent } from '../../shared/notification/notification.component';
import { NgIf } from '@angular/common';
import { OnlyNumberDirective } from '../../shared/directives/only-number.directive';
import { Meta, Title } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-contact-us',
    imports: [
        FormsModule,
        NotificationsComponent,
        NgIf,
        OnlyNumberDirective
    ],
    templateUrl: './contact-us.component.html',
    styleUrl: './contact-us.component.scss'
})
export class ContactUsComponent implements OnInit {
  pagesService = inject(PagesService);
  private meta = inject(Meta);
  private title = inject(Title);
  
  ngOnInit(): void {
    this.pagesService.restartSideMenu();
    this.setUpSEOTags();
  }

  private setUpSEOTags() {
    const { baseTitle, baseURL, type } = environment.config.seo;
    const url = 'pages/contact-us'
    const component = 'Contact Us'
    const title = `${component} | ${baseTitle}`;

    // Page title
    this.title.setTitle(title);

    // Open Graph for social networks:
    this.meta.addTag({ property: 'og:title', content: title });
    this.meta.addTag({ property: 'og:url', content: `${baseURL}${url}` });
    this.meta.addTag({ property: 'og:type', content: type });
  }

}
